import type { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { formatXeroMappingOption } from 'Products/constants/xeroMapping.constants'

type XeroLedgerAccountMapping =
  Dashboardv99990101Api.GetXeroLedgerAccountMappings.GetXeroLedgerAccountMappingsResponse['items'][number]

export type XeroAccountOptions = {
  count: number
  options: { label: string; value: string }[]
  initialId?: string
}

export const buildXeroAccountOptions = (
  mappings: XeroLedgerAccountMapping[],
  mappableLedgerAccount: XeroLedgerAccountMapping['mappableLedgerAccount']
): XeroAccountOptions => {
  const accountMappings = mappings.filter(
    mapping => mapping.mappableLedgerAccount === mappableLedgerAccount
  )

  const options = accountMappings.map(
    ({ id, xeroLedgerAccountCode, xeroLedgerAccountName, isDefault }) => {
      const label = formatXeroMappingOption(
        xeroLedgerAccountCode,
        xeroLedgerAccountName
      )
      return {
        label: isDefault ? `${label} (default)` : label,
        value: id
      }
    }
  )

  const initialId = (
    accountMappings.find(({ isDefault }) => isDefault) ?? accountMappings[0]
  )?.id

  return { count: accountMappings.length, options, initialId }
}
